'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$101() {
  this.c1t = null;
  this.c1u = false;
}
export { $c_Lpresto_types$$anon$101 as $c_Lpresto_types$$anon$101 };
$p = $c_Lpresto_types$$anon$101.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$101;
/** @constructor */
function $h_Lpresto_types$$anon$101() {
}
export { $h_Lpresto_types$$anon$101 as $h_Lpresto_types$$anon$101 };
$h_Lpresto_types$$anon$101.prototype = $p;
$p.P = (function() {
  if ((!this.c1u)) {
    this.c1t = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c1u = true;
  }
  return this.c1t;
});
var $d_Lpresto_types$$anon$101 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$101, "presto.types$$anon$101", ({
  Yp: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$101 as $d_Lpresto_types$$anon$101 };
//# sourceMappingURL=presto.types$$anon$101.js.map
